import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './styles.scss'

const BlankStateSection = ({
  children, direction, imageAlt, imageUrl, style,
}) => (
  <div className={classnames(styles.root, direction === 'column' ? styles.column : null)} style={style}>
    <div className={styles.left}>{children}</div>

    {imageUrl && (
      <div className={styles.right}>
        <img alt={imageAlt || 'Hint'} src={imageUrl} />
      </div>
    )}
  </div>
)

BlankStateSection.propTypes = {
  children: PropTypes.node,
  direction: PropTypes.string,
  imageAlt: PropTypes.string,
  imageUrl: PropTypes.string,
  style: PropTypes.object,
}

export default BlankStateSection
